/* Shared HLS handling for the videos rendered by snippets/ls-background-video.liquid. */

// Chrome and Firefox answer "maybe" to the HLS mime type but cannot decode it, so
// canPlayType is no help — only Safari streams these natively. Setting src wins over
// the <source> children, and any load error drops straight back to the mp4.
window.lsApplyHlsSource = function (video, onFallback) {
  if (!video || !video.dataset.hlsSrc) return;
  if (!/^((?!chrome|chromium|crios|android|firefox|fxios|edg).)*safari/i.test(navigator.userAgent)) return;

  video.addEventListener('error', function () {
    if (!video.getAttribute('src')) return;
    video.removeAttribute('src');
    // The mp4 re-buffers from scratch, so stop covering whatever is painted underneath.
    video.classList.remove('is-ready');
    video.load();
    if (typeof onFallback === 'function') onFallback();
  }, { once: true });

  video.src = video.dataset.hlsSrc;
};
